import {
  SAVE_FILTERS, CLEAR_FILTERS,
  SAVE_TICKETS_FILTERS, CLEAR_TICKETS_FILTERS
} from './action-types';

export const saveFilters = payload =>{
  return ({
    type: SAVE_FILTERS,
    payload: {
      [payload.type]: payload.value,
    },
  });
}

export const clearFilters = payload => ({
  type: CLEAR_FILTERS,
  payload: {
    [payload.type]: null,
  },
});

export const saveTicketsFilters = filters => {
  return {
    type: SAVE_TICKETS_FILTERS,
    filters
  }
}

export const clearTicketsFilters = filters => {
  return {
    type: CLEAR_TICKETS_FILTERS
  }
}



// WEBPACK FOOTER //
// ./src/actions/filters-actions.js